import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Renderer2,
	ElementRef,
	AfterViewInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { UtilsService } from '../../services/utils.service';
import { ICodeService, ICodeInput } from '../../services/icode.service';
import { IUserData, UserData } from '../../../globals/classes/userData';
import { BaseComponent } from '../../../globals/classes/base.component';
import { Constants } from '../../classes/static/constants';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'i-code',
	template: require('./i-code.component.html'),
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ICodeComponent extends BaseComponent implements OnInit, AfterViewInit {
	public code: string = '';
	public config: ICodeInput[];
	public instructionsLabel: string = 'Συμπληρώστε τον κωδικό επιβεβαίωσης OTP που λάβατε στο';
	public timer: Date = new Date();
	public count = 300;
	public countDown: Observable<number>;
	public userData: IUserData = new UserData();
	public isSmsOtp: boolean;
	public maskedPhoneNumber: string;
	public modalService: any;
	public isCorporate: boolean;
	public isRebrading = AppSettings.isRebrading;

	private _icodeReceived: boolean;

	public set icodeReceived(value: boolean) {
		this._icodeReceived = value;
		if (value === false) this.code = '';
		this._detectChanges();
	}

	public get icodeReceived() {
		return this._icodeReceived;
	}

	constructor(
		public utilsService: UtilsService,
		private _change: ChangeDetectorRef,
		private elRef: ElementRef,
		private _renderer2: Renderer2,
		private icodeService: ICodeService
	) {
		super();
		this.config = icodeService.config;
	}

	public ngOnInit(): void {
		this.mortalize(UserData.data$).subscribe((userData) => this._userDataReceived(userData));
		this.mortalize(this.icodeService.newCodeSent$).subscribe((codeLifetime) =>
			this._initCountdown(codeLifetime)
		);
		this.icodeService.resetTimer();
	}

	public ngAfterViewInit(): void {
		this._setUpKeyListener();
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this.icodeService.clearCode();
	}

	public resendCode(): void {
		this.icodeService.requestCode();
	}

	public inputChange(event: any) {
		const code = event.target.value.replace(/\s/g, '');
		this.icodeService.updateCode(code);
	}

	public onKeyDown(event: KeyboardEvent, prefix: string, index: number) {
		event.cancelBubble = true;
		event.stopPropagation();
		event.returnValue = true;
		this.icodeService.moveCursor(event, prefix, index, this._renderer2);
	}

	private _setUpKeyListener(): void {
		this.elRef.nativeElement.addEventListener('keydown', (e: any) => {
			const key = e.which || e.keyCode;
			if (key === Constants.KEY_ENTER) {
				this.preventEventPropagation(e);
				if (this.icodeService.isValidCode(this.code)) this.icodeService.codeSubmitted();
			}
		});
	}

	private preventEventPropagation(e: any) {
		e.stopPropagation();
		e.preventDefault();
	}

	private _initCountdown(codeLifetime = this.count): void {
		this.icodeReceived = true;
		this.countDown = this._createTimer(codeLifetime);
		this.mortalize(this.countDown).subscribe((data) => {
			if (data === 0) {
				this._countdownFinished();
			}
		});
	}

	private _createTimer(count: number): Observable<number> {
		return timer(0, 1000).pipe(
			map((value: number) => count - value),
			takeWhile((value: number) => value >= 0)
		);
	}

	private _countdownFinished(): void {
		this.icodeService.clearCode();
		this.icodeReceived = false;
	}

	private _userDataReceived(data: IUserData): void {
		this.userData = data;
		if (!this.userData) return;
		this.isSmsOtp = this.userData.hasSMSOtp;
		this.maskedPhoneNumber = this.userData.maskedPhoneNumber;
		this.isCorporate = UserData.isCorporate(data.userType);
		this._detectChanges();
	}

	private _detectChanges(): void {
		setTimeout(() => {
			if (this.isDestroyed) return;
			this._change.markForCheck();
			this._change.detectChanges();
		});
	}
}
